// extracted by mini-css-extract-plugin
export default {"root":"Grid_root__YLebA","movein":"Grid_movein__3fVml"};